import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCreativecommonsComponent } from './simple-icons-creativecommons.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCreativecommonsComponent ],
    exports:      [ SimpleIconsCreativecommonsComponent ],
    bootstrap:    []
})
export class SimpleIconsCreativecommonsModule {}
